export function module_market() {
  $(function() {
    // Slickスライダーの初期化状態を追跡
    let slickInitialized = false;
    
    // リサイズ用関数の定義
    function marketContents() {
      // メインビジュアルの画像を背景として指定
      $(".marketSlider__item img").each(function() {
        // メインビジュアルのsrcを取得
        var mainSrc = "url(" + $(this).attr("src") + ")";
        // 取得したsrcを親の要素の背景として指定
        $(this).parents(".marketSlider__item").css("background-image", mainSrc);
      });

      // Slickが既に初期化されている場合は一度破棄
      if (slickInitialized) {
        $(".marketSlider").slick('unslick');
      }

      // Slick SlideShow の初期化
      $(".marketSlider").slick({
        autoplay: true, // 自動でスクロール
        autoplaySpeed: 0, // 自動再生のスライド切り替えまでの時間を設定
        speed: 10000, // スライドが流れる速度を設定
        cssEase: "linear", // スライドの流れ方を等速に設定
        slidesToShow: 4, // 表示するスライドの数
        swipe: false, // 操作による切り替えはさせない
        arrows: false, // 矢印非表示
        pauseOnFocus: false, // スライダーをフォーカスした時にスライドを停止させるか
        pauseOnHover: false, // スライダーにマウスホバーした時にスライドを停止させるか
        responsive: [
          {
            breakpoint: 750,
            settings: {
              slidesToShow: 3, // 画面幅750px以下でスライド3枚表示
            },
          },
        ],
      });
      
      // スライダーが初期化されたことを記録
      slickInitialized = true;
    }
    
    // 初期実行
    marketContents();
    
    // リサイズ処理
    var timer = false;
    var winWidth = $(window).width();
    var winHeight = $(window).height();
    
    $(window).on("resize", function() {
      // リサイズ中の連続実行を防止
      if (timer !== false) {
        clearTimeout(timer);
      }
      
      // 指定時間後に処理を実行
      timer = setTimeout(function() {
        // リサイズ後のウインドウのサイズを取得
        const winWidth_resized = $(window).width();
        const winHeight_resized = $(window).height();
        
        // サイズが変わった場合のみ処理を実行
        if (winWidth !== winWidth_resized || winHeight !== winHeight_resized) {
          marketContents();
          
          // 次回比較用にサイズを更新
          winWidth = winWidth_resized;
          winHeight = winHeight_resized;
        }
      }, 200);
    });
  });
}